export default __webpack_public_path__ + "static/media/under-construction.95c28e81.jpg";